import {useEffect, useState} from "react";

import moment from "moment";
import {useStore} from "../../../../../../hooks/useStore";
import {useFetch} from "../../../../../../hooks/useFetch";

export const useCourierWalletPaymentSubTab = ({
    courier, 
    canRender = false, 
    selectedDateRange = [moment().subtract(7, "day"), moment()],
    onDateRangeChange = () => {}
}) => {
    const stores = useStore();
    const [selectedCourierWalletPayment, setSelectedCourierWalletPayment] = useState(null);

    const [courierWalletPaymentsResultLoading, courierWalletPaymentsResult] = useFetch({
        fetchFn: stores.walletStore.getCourierWalletPayments.bind(null, {
            courierId: courier?._id,
            startDate: selectedDateRange?.[0]?.format("YYYY-MM-DD"),
            endDate: selectedDateRange?.[1]?.format("YYYY-MM-DD")
        }),
        dependencies: [courier?._id, JSON.stringify(selectedDateRange), canRender],
        initialCall: canRender,
        condition: Boolean(courier?._id) && canRender
    });

    useEffect(() => {
        resetSelectedCourierWalletPayment();
    }, [canRender]);

    const resetSelectedCourierWalletPayment = () => {
        setSelectedCourierWalletPayment(null);
    };

    const handleDateRangeChange = async dates => {
        resetSelectedCourierWalletPayment();
        if (!dates || !dates[0] || !dates[1]) {
            onDateRangeChange(null);
            return;
        }
        onDateRangeChange([moment(dates[0]), moment(dates[1])]);
    };

    const handleCourierWalletPaymentSelect = courierWalletPaymentId => {
        const item = courierWalletPaymentsResult?.courierWalletPayments?.find(
            courierWalletPayment =>
                courierWalletPayment?._id?.toString() === courierWalletPaymentId?.toString()
        );

        setSelectedCourierWalletPayment(item);
    };

    return {
        courierWalletPaymentsResultLoading,
        courierWalletPayments: courierWalletPaymentsResult?.courierWalletPayments || [],
        selectedCourierWalletPayment,
        selectedDateRange: selectedDateRange,
        handleDateRangeChange: onDateRangeChange || handleDateRangeChange,
        handleCourierWalletPaymentSelect
    };
};
